import { useToast } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';
import { useAnalytics } from 'use-analytics';
import { getSWRConfig } from './utils/get-swr-config';

export const CaSWRConfig: React.FC<PropsWithChildren> = ({ children }) => {
  const toast = useToast();
  const analytics = useAnalytics();

  return <SWRConfig value={getSWRConfig(toast, analytics)}>{children}</SWRConfig>;
};
